import { render, staticRenderFns } from "./bento.vue?vue&type=template&id=676e0876&scoped=true"
import script from "./bento.vue?vue&type=script&lang=js"
export * from "./bento.vue?vue&type=script&lang=js"
import style0 from "./bento.vue?vue&type=style&index=0&id=676e0876&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676e0876",
  null
  
)

export default component.exports